import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { oAuthConfig } from './auth.config';

@Injectable({ providedIn: 'root' })
export class AuthService {
  constructor(private oauthService: OAuthService) {
    this.oauthService.configure(oAuthConfig);
    this.oauthService.setupAutomaticSilentRefresh();
  }

  async initAuth(): Promise<void> {
    await this.oauthService.loadDiscoveryDocument();
  }

  loginComGovBR(): void {
    this.initAuth().then(() => {
      this.oauthService.initCodeFlow();
    });
  }

  logout(): void {
    this.oauthService.logOut();
  }

  get token(): string | null {
    return this.oauthService.getAccessToken();
  }

  get userInfo(): any {
    return this.oauthService.getIdentityClaims();
  }

  get autenticado(): boolean {
    return this.oauthService.hasValidAccessToken();
  }
}
